export const ROUTE_NAME = {
    MATCH: 'user_match',
    FINISH_MATCH: 'user_finish_match',
    FINISH_CARD: 'user_finish_card',
    PARTICIPATION_CERTIFICATES: 'participation_certificates',
    ACTIVITY_CERTIFICATES: 'activity_certificates',
    ACTIVITY_CERTIFICATES_NEW: 'activity_certificates_new',
};
